import { CalendarClock, FileText, Gauge, Network, Package, Settings2, ShieldCheck, Sparkles, Users, Wrench } from "lucide-react";

export const FOYER_TABS = [
  { value: "equipements", label: "Équipements", icon: Package },
  { value: "consommations", label: "Consommations", icon: Gauge },
  { value: "entretiens", label: "Entretiens", icon: CalendarClock },
  { value: "sav", label: "Réparations", icon: Wrench },
  { value: "assurances", label: "Assurances", icon: ShieldCheck },
  { value: "cartographie", label: "Fournisseurs", icon: Network },
  { value: "documents", label: "Documents", icon: FileText },
  { value: "membres", label: "Membres", icon: Users },
  { value: "parametres", label: "Paramètres", icon: Settings2 },
  { value: "modules", label: "À venir", icon: Sparkles },
];
